"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showQuestionDialog = exports.DialogButtonResult = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var TestIds_1 = require("../../util/TestIds");
var DialogButtonResult;
(function (DialogButtonResult) {
    DialogButtonResult["OK"] = "OK";
    DialogButtonResult["Cancel"] = "Cancel";
})(DialogButtonResult = exports.DialogButtonResult || (exports.DialogButtonResult = {}));
/**
 * Used to display a simple question dialog with 2 answer buttons, like: Do you want to delete user bob? With buttons Cancel and Delete.
 * Returns a Promise containing the DialogButtonResult associated with the button the user pressed.
 * @param title The title of the dialog, typically the same as the okButton.
 * @param message The question to ask.
 * @param okButton The name of the okButton. Typically the verb answer to the question.
 * @param okButtonType The ButtonType for the okButton
 * @param cancelButton An optional cancel button name.
 * @returns Promise<DialogButtonResult>
 */
var showQuestionDialog = function (title, message, okButton, okButtonType, cancelButton) {
    if (okButtonType === void 0) { okButtonType = widgets_1.ButtonType.Primary; }
    if (cancelButton === void 0) { cancelButton = Localize_1.Messages.simpleDialogDefaultCancelButton(); }
    var _resolve;
    var result = new Promise(function (resolve) {
        _resolve = resolve;
    });
    var hostContainer = new widgets_1.HostedStackedElementContainer();
    var closeDialog = function (result) {
        hostContainer && hostContainer.remove();
        _resolve(result);
    };
    var dialogContents = (React.createElement(widgets_1.DialogWidget, { dialogWidth: 400, footerContent: React.createElement(widgets_1.DialogFooterButtonsWidget, { buttons: [
                {
                    buttonType: widgets_1.ButtonType.LowEmphasis,
                    children: cancelButton,
                    onClick: function () { return closeDialog(DialogButtonResult.Cancel); },
                },
                {
                    buttonType: okButtonType,
                    children: okButton,
                    onClick: function () { return closeDialog(DialogButtonResult.OK); },
                },
            ] }), isModal: true, showCloseButton: false, onCloseRequest: function () { return closeDialog(DialogButtonResult.Cancel); }, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, title: title, testId: TestIds_1.SIMPLE_QUESTION_DIALOG_TEST_ID, type: widgets_1.DialogType.NormalWithTitleBar },
        React.createElement("div", null, message)));
    hostContainer.render(dialogContents);
    return result;
};
exports.showQuestionDialog = showQuestionDialog;
//# sourceMappingURL=SimpleDialogs.js.map